var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-card-ll" }, [
    _c(
      "div",
      { staticClass: "accont-area flex-row-start-center" },
      [
        _c("img", { attrs: { src: _vm.img.userIcon, width: "48", alt: "" } }),
        _vm._v(" "),
        _c("span", { staticClass: "fs-14 account-label" }, [
          _vm._v("连连账号:")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fs-14 account-value" }, [
          _vm._v(_vm._s(_vm.pageAccountWithCorpInfoVO.clearingAccountNo))
        ]),
        _vm._v(" "),
        _c(
          "el-tag",
          {
            class:
              "fs-14 tag-color " +
              (_vm.pageActivationVO.activation
                ? "has-activation"
                : "not-activation")
          },
          [
            _vm._v(
              _vm._s(_vm.pageActivationVO.activation ? "已激活" : "未激活")
            )
          ]
        ),
        _vm._v(" "),
        !_vm.pageActivationVO.activation
          ? _c("span", { staticClass: "not-activation-label fs-14" }, [
              _vm._v("连连账户钱袋提现前，需要激活账户")
            ])
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "man-content-area" }, [
      _c("div", { staticClass: "card-item" }, [
        _c(
          "div",
          { staticClass: "card-title flex-row-between-center" },
          [
            _c(
              "div",
              { staticClass: "title-left flex-flex1 flex-row-start-center" },
              [
                _c("img", {
                  attrs: { src: _vm.img.bankLogo, width: 20, alt: "" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "title-text" }, [_vm._v("银行信息")])
              ]
            ),
            _vm._v(" "),
            _vm.pageAccountWithModifyBankVo.status === 1
              ? _c("el-alert", {
                  staticClass: "is-going",
                  attrs: {
                    title: "换绑中，请耐心等待...",
                    type: "info",
                    "show-icon": ""
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 8 } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("账户类型:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "对公账户"
                                    : " 个人账户"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "账户名称:"
                                    : "银行户名:"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskName",
                                maskVal:
                                  _vm.pageAccountWithBankAccountVO.accountName,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.accountType
                                  ? _vm.pageAccountWithBankAccountVO
                                      .accountType === 1
                                    ? "账户号码:"
                                    : "银行卡号:"
                                  : ""
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskBankCard",
                                maskVal:
                                  _vm.pageAccountWithBankAccountVO
                                    .accountNumber,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("银行卡预留手机号:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskPhone",
                                maskVal:
                                  _vm.pageAccountWithBankAccountVO.reservePhone,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户银行:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.bankName
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.activationVO.activation &&
                        _vm.pageAccountWithModifyBankVo.status !== 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "jump-qf-btn",
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.handleJumpUpdateCard }
                              },
                              [_vm._v("换绑银行卡")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("省份:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.provinceName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("市/县:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.cityName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户支行:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.branchBankName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("开户行地址:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithBankAccountVO.branchBankName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-item" }, [
        _c(
          "div",
          { staticClass: "card-title flex-row-between-center" },
          [
            _c(
              "div",
              { staticClass: "title-left flex-flex1 flex-row-start-center" },
              [
                _c("img", {
                  attrs: { src: _vm.img.accountLogo, width: 20, alt: "" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "title-text" }, [_vm._v("商户信息")])
              ]
            ),
            _vm._v(" "),
            _vm.pageAccountWithModifyPhoneVo.status === 1
              ? _c("el-alert", {
                  staticClass: "is-going",
                  attrs: {
                    title: "换绑中，请耐心等待...",
                    type: "info",
                    "show-icon": ""
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 8 } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("法定代表人:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskName",
                                maskVal: _vm.pageAccountWithUserInfoVO.realName,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("证件类型:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [_vm._v("身份证")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("证件号码:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskBankCard",
                                maskVal:
                                  _vm.pageAccountWithUserInfoVO.certNumber,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("法定代表人手机号:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskPhone",
                                maskVal: _vm.pageAccountWithUserInfoVO.mobile,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("注册邮箱:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskEmail",
                                maskVal: _vm.pageAccountWithCorpInfoVO.mail,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("企业名称:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.pageAccountWithCorpInfoVO.corpName) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("营业执照类型:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithCorpInfoVO.licenseType === 1
                                  ? "有限公司"
                                  : _vm.pageAccountWithCorpInfoVO
                                      .licenseType === 2
                                  ? "个人独资企业"
                                  : "个体工商户"
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("营业执照企业名称:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithCorpInfoVO.licenseName
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("注册手机号:")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "value" },
                          [
                            _c("MaskViewVue", {
                              attrs: {
                                type: "maskPhone",
                                maskVal: _vm.pageAccountWithCorpInfoVO.phone,
                                customParams: {
                                  expand: JSON.stringify({
                                    xAPIVersion: "V1.0",
                                    xSystemID: "passport"
                                  })
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.activationVO.activation &&
                        _vm.pageAccountWithModifyPhoneVo.status !== 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "jump-qf-btn",
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.handleJumpUpdatePhone }
                              },
                              [_vm._v("换绑注册手机号")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("统一社会信用代码:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithCorpInfoVO.licenseNumber
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("证件有效期:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                (_vm.pageAccountWithUserInfoVO.validBeginTime ||
                                  "") +
                                  "——" +
                                  (_vm.pageAccountWithUserInfoVO.validTerm
                                    ? _vm.pageAccountWithUserInfoVO.validTerm
                                    : _vm.pageAccountWithUserInfoVO
                                        .validEndTime || "")
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-row-start-center flex-item" },
                      [
                        _c("div", { staticClass: "label" }, [
                          _vm._v("企业地址:")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.pageAccountWithCorpInfoVO.detailAddress
                              ) +
                              "\n              "
                          )
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    !_vm.activationVO.activation
      ? _c(
          "div",
          { staticClass: "not-activation-btn-area" },
          [
            _c(
              "el-button",
              {
                staticClass: "jump-qf-btn",
                attrs: { type: "primary", size: "large" },
                on: { click: _vm.handleJumpActivation }
              },
              [_vm._v("去激活")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71da9778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71da9778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purseSetting/binding/components/accountCardLL.vue
// module id = null
// module chunks = 